import axios from 'axios'
import router from '@/router/routers'
import store from '@/store'
import { MessageBox, Notification } from 'element-ui'
let confirmation = null;

// import Config from '@/settings'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1200000// 请求超时时间
})

// const noPidWhiteList = ['/school/login', '/user/info', '/school/user/info', '/school/schools', '/school/user/bindSchool']

// request拦截器
service.interceptors.request.use(
  config => {
    // let token = getUserAccessToken() || ''
    // if(token) {
    //   let tokenObj = JSON.parse(token.split('think:')[1])
    //   config.headers['Authorization'] = 'Bearer ' + tokenObj.token.access_token // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    config.headers['Guard'] = 'user';
    config.headers['Client-Type'] = 'pc';
    // if (!noPidWhiteList.includes(config.url.split('?')[0])) {
    //   if(!store.state.loginUserInfo.partner) {
    //     router.push('/scList')
    //     return config
    //   }
    //   config.headers['Pid'] = store.state.loginUserInfo.partner.id;
    // }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // if (response.data.code == 401 || response.data.code == 402) {
    //   if(!confirmation) {
    //     confirmation = MessageBox.confirm(
    //       response.data.message,
    //       {
    //         center: true,
    //         showClose: false,
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         showCancelButton: false,
    //         closeOnClickModal: false,
    //         type: 'warning'
    //       }
    //     ).then(() => {
    //       removeToken();
    //       // location.reload()
    //     }).finally(() => {
    //       confirmation = null
    //     })
    //   }
    //   return Promise.reject('error')
    // }
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      return Promise.reject('error')
    } else {
      if (response.data.code != 206) {
        // 聊天中接口响应处理
        if (response.config.headers.chatApi) {
          if (response.data.code == 200) {
            return response.data
          } else {
            return Promise.reject(response.data)
          }
        }
        return response.data
      }

    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 5000
        })
        return Promise.reject(error)
      }
    }
    if (code) {
      if (code === 401) {
        ElMessage.confirm(
          '登录状态已过期，您可以继续留在该页面，或者重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          removeToken();
          // router.push({ path: '/' })
          location.reload()
        })
      } else if (code === 403) {
        router.push({ path: '/401' })
      } else {
        const errorMsg = error.response.data.message
        if (errorMsg !== undefined) {
          Notification.error({
            title: errorMsg,
            duration: 5000
          })
        }
      }
    } else {
      console.log(error)
      Notification.error({
        title: '接口请求失败',
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)


export default service
